import { selectIsDynamicContentReportingSnippetsFeatureFlagOn } from 'core/userContext';
import { useSelector } from 'react-redux';
import {
  useCampaignAndMetricFiltersContext,
  useTabContext,
  useTabSpecificFiltersContext,
  useTimeFiltersContext,
} from '../context';
import { AllFilters } from '../types';

export const useGetAllUrlFilters = () => {
  const isDCRFFOn = useSelector(selectIsDynamicContentReportingSnippetsFeatureFlagOn);
  const { selectedMediums, selectedCrossMetrics, campaignFilters } =
    useCampaignAndMetricFiltersContext();

  const { dateParams, timezone, timePreset } = useTimeFiltersContext();
  const {
    selectedSegment,
    region,
    campaignsSortDirection,
    campaignsSortedBy,
    audienceSortDirection,
    audienceSortedBy,
    snippetsSortDirection,
    snippetsSortedBy,
  } = useTabSpecificFiltersContext();
  const { selectedTab } = useTabContext();
  const allFilters: AllFilters = {
    selectedMediums,
    selectedCrossMetrics,
    campaignFilters,
    timezone,
    timePreset,
    dateParams,
    selectedTab,
    selectedSegment,
    region,
    campaignsSortDirection,
    campaignsSortedBy,
    audienceSortDirection,
    audienceSortedBy,
  };
  if (isDCRFFOn) {
    allFilters.snippetsSortDirection = snippetsSortDirection;
    allFilters.snippetsSortedBy = snippetsSortedBy;
  }
  return allFilters;
};
